
import React from "react";
import { Provider } from "react-redux";
import { submitFeedbackStore } from "./state/submit_feedback_store";
import SubmitFeedbackComp from "./components/submit_feedback_comp";

import PageComponent from '../../components/page/page_comp';

const SubmitFeedbackPage = () => {
    return PageComponent({
        content: <Provider store={submitFeedbackStore}>
            <SubmitFeedbackComp/>
        </Provider>,
        showFooter: false,
    })
}

export default SubmitFeedbackPage